import { render, staticRenderFns } from "./work_reply.vue?vue&type=template&id=6c96f9ba"
import script from "./work_reply.vue?vue&type=script&lang=js"
export * from "./work_reply.vue?vue&type=script&lang=js"
import style0 from "./work_reply.vue?vue&type=style&index=0&id=6c96f9ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports